//@ts-ignore
import plugin0 from "fireside-plugin-background-color"
//@ts-ignore
import plugin1 from "fireside-plugin-component-gap"
//@ts-ignore
import plugin2 from "@kaminrunde/fireside-plugin-ab-test"
//@ts-ignore
import plugin3 from "@kaminrunde/fireside-plugin-copy-component"


export default {
  "fireside-plugin-background-color": plugin0,
  "fireside-plugin-component-gap": plugin1,
  "@kaminrunde/fireside-plugin-ab-test": plugin2,
  "@kaminrunde/fireside-plugin-copy-component": plugin3,
}